<header class="sysbar" [dir]="textDir"> 
  <div class="items-container">
    <div class="item" routerLink="/">
      <i class="icon icon-econ"></i>
      <span class="product" *ngIf="this.route !== 'dashboard'">Connect To Learn</span>
      <span class="product" *ngIf="this.route === 'dashboard'">Connect To Learn Analytics </span>
      <span class="acronym">CTL</span>
    </div>
  </div>
  <div class="items-container cur-def">
    <div class="item marR0" *ngIf="isLoggedin">   
      <span *ngIf="loginInfoObj?.project && isLoggedin?.role?.name == 'ProjectAdmin'">{{loginInfoObj?.project?.name}}  &nbsp;&nbsp;| &nbsp;&nbsp; </span> 
      <span *ngIf="loginInfoObj?.school && isLoggedin?.role?.name == 'SchoolAdmin' " class="capitalize">{{loginInfoObj?.school?.name}}  &nbsp;&nbsp;| &nbsp;&nbsp; </span>
      <span *ngIf="loginInfoObj?.school && isLoggedin?.role?.name == 'Teacher'" class="capitalize">{{loginInfoObj?.school?.name}}  &nbsp;&nbsp;| &nbsp;&nbsp; {{loginInfoObj?.domain}}  &nbsp;&nbsp;| &nbsp;&nbsp; </span>
      {{isLoggedin?.role?.desc}} &nbsp;&nbsp; |    
      </div>
      <div #logoutDropdown class="dropdown dropdown-user" data-type="click" *ngIf="isLoggedin" [dir]="textDir">
      <button class="btn clickable user-btn capitalize" (click)='showDropdown()' [dir]="textDir"> <i  class="icon icon-profile font18" [ngClass]="textDir=='rtl'?'marL5':''"></i> {{isLoggedin?.username}}</button>
      <div #menu class="menu">
        <div class="item" (click)='logoutFunc()' [dir]="textDir"><i class="icon icon-logout"></i> {{'Logout'| translate}}</div>
      
      </div>
    </div>
  </div>
</header>


<div #timerDialog class="dialog timer-dialog" data-trigger="#timerDialog" data-type="simple" [dir]="textDir">
  <div class="content">
  <div class="top">
   
    <div class=""  [ngClass]="textDir=='ltr'?'left':'right'" > 
      <div class="icon-holder" [ngClass]="subtitleMessage=='Your session has expired'?'eds-grey':'eds-red'">
     <!--  <img src="../../assets/images/timer-icon.png" width='29' height='29'> -->
      <div class="vertical-center" [dir]="textDir"><i class="icon icon-time"></i></div>

      </div>
      <div class="title marT5" [ngClass]="textDir=='ltr'?'marL15':'marR15'">      
        {{'Session expiry' |translate}}
      </div>
      
    </div>
  </div>
  <div class="body" [dir]="textDir">
    <label class="timer-txt">{{subtitleMessage}}</label>
              
    <label class="timer-txt marT10">{{detailMessage}}</label>  


   
  </div>
  <div class="bottom" [dir]="textDir">
    <button class="btn ghost" data-close="true" (click)="logoutSession()" *ngIf="minutesDisplay >= (userIdleTime-beforeExpiryTime) && minutesDisplay < (userIdleTime) && secondsDisplay <60" [dir]="textDir">{{'Log out' | translate}}</button>
    <button class="btn primary" (click)="continueSession()" [dir]="textDir">{{'Continue' | translate}}</button>
  </div>
  </div>
</div>
 